export default __webpack_public_path__ + "static/capital-4cc20802137e54eca59db3ffee908d32.png";